import { render, staticRenderFns } from "./wy-target-number-range.vue?vue&type=template&id=477c55ad&"
import script from "./wy-target-number-range.vue?vue&type=script&lang=js&"
export * from "./wy-target-number-range.vue?vue&type=script&lang=js&"
import style0 from "./wy-target-number-range.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports